module.exports = __webpack_public_path__ + "static/mcdonalds-9c164af5a6678787ffb882cc8d1e6125.jpg";